module.exports = __webpack_public_path__ + "img/GBM1_CD8Tex.74fc3503.png";